import type { AvailableSlotsQueryDTO, AvailableSlotsQueryProps } from "./available-slots.types";

import { getAvailableSlotsEndpoint } from "../endpoints";

export async function getAvailableSlots({
  urlSlug,
  dates,
  timezone,
}: AvailableSlotsQueryProps): Promise<AvailableSlotsQueryDTO> {
  const response = await fetch(
    `${getAvailableSlotsEndpoint}/${urlSlug}/time-slots?from=${dates.from}&to=${
      dates.to
    }&timezone=${encodeURIComponent(timezone)}&with_details=1`,
  );
  if (!response.ok) {
    if (response.status === 404) {
      return response.json();
    }
  }
  return response.json();
}
